import { createSelector } from 'reselect';

import googlePayItemFromPurchase from '../utils/ordering/googlePayItemFromPurchase';

import getStagedPurchases from './getStagedPurchases';

export default createSelector([getStagedPurchases], purchases =>
  purchases.map(googlePayItemFromPurchase),
);
